import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Trash2, Minus, Plus, ShoppingCart } from 'lucide-react';
import { useCart, formatPrice } from '../contexts/CartContext';

const CartPage = () => {
  const { items, totalCents, setQuantity, remove, count } = useCart();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
        <Link to="/boutique" className="inline-flex items-center gap-2 text-gray-400 hover:text-red-400 mb-6">
          <ArrowLeft className="w-4 h-4" /> Retour à la boutique
        </Link>

        <h1 className="text-3xl sm:text-4xl font-bold mb-8 bg-gradient-to-r from-red-400 to-sky-400 bg-clip-text text-transparent">
          Votre panier
        </h1>

        {count === 0 ? (
          <div className="text-center py-16 border border-gray-800 rounded-2xl bg-gray-900/20">
            <ShoppingCart className="w-12 h-12 mx-auto text-gray-600 mb-4" />
            <p className="text-gray-400 mb-6">Votre panier est vide.</p>
            <Link to="/boutique" className="px-6 py-3 rounded-full bg-red-600 hover:bg-red-700 text-white font-medium">
              Découvrir la boutique
            </Link>
          </div>
        ) : (
          <>
            <div className="space-y-4">
              {items.map((item) => (
                <div key={item.productId} className="flex items-center gap-4 p-4 border border-gray-800 rounded-xl bg-gray-900/30">
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold truncate">{item.name}</p>
                    <p className="text-red-400">{formatPrice(item.priceAmount)}</p>
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => setQuantity(item.productId, item.quantity - 1)}
                      className="p-1 rounded-md border border-gray-700 hover:bg-gray-800"
                      aria-label="Diminuer"
                    >
                      <Minus className="w-4 h-4" />
                    </button>
                    <span className="w-8 text-center">{item.quantity}</span>
                    <button
                      onClick={() => setQuantity(item.productId, item.quantity + 1)}
                      disabled={item.quantity >= item.maxQuantity}
                      className="p-1 rounded-md border border-gray-700 hover:bg-gray-800 disabled:opacity-40"
                      aria-label="Augmenter"
                    >
                      <Plus className="w-4 h-4" />
                    </button>
                  </div>

                  <div className="w-24 text-right font-semibold">{formatPrice(item.priceAmount * item.quantity)}</div>

                  <button onClick={() => remove(item.productId)} className="p-2 text-gray-500 hover:text-red-400" aria-label="Retirer">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 p-6 border border-gray-800 rounded-xl bg-gray-900/30">
              <div>
                <p className="text-gray-400 text-sm">Sous-total (hors livraison)</p>
                <p className="text-2xl font-bold">{formatPrice(totalCents)}</p>
              </div>
              <button
                onClick={() => navigate('/commande')}
                className="px-8 py-3 rounded-full bg-gradient-to-r from-red-500 to-sky-500 text-white font-semibold hover:shadow-xl hover:shadow-sky-500/30 transition-all"
              >
                Passer la commande
              </button>
            </div>
            <p className="text-gray-500 text-xs mt-3 text-center">
              Les frais de livraison sont calculés à l'étape suivante selon le mode choisi.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default CartPage;
